import AlertDialog, {
  AlertDialogAction,
  AlertDialogCancel as AlertDialogCancelComponent,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@cobliteam/ui/components/AlertDialog';

export interface AlertDialogCancelProps {
  open: boolean;
  title?: string;
  description?: string;
  confirmLabel?: string;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
}

const AlertDialogCancel = ({
  open,
  title = 'Sair sem salvar?',
  description = 'Você editou informações que não foram salvas.\nDeseja sair mesmo assim?',
  confirmLabel = 'Sair sem salvar',
  onOpenChange,
  onConfirm,
}: AlertDialogCancelProps) => {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className='text-black'>{title}</AlertDialogTitle>
          <AlertDialogDescription className='whitespace-pre-line'>{description}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancelComponent>Cancelar</AlertDialogCancelComponent>
          <AlertDialogAction color='danger' onClick={onConfirm}>
            {confirmLabel}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default AlertDialogCancel;
